<template>
  <div>
    <el-form size="small" inline>
      <el-form-item label="名称">
        <el-input v-model="conditions.name" />
      </el-form-item>
      <el-form-item label="编码">
        <el-input v-model="conditions.code" />
      </el-form-item>
      <el-form-item>
        <el-button :loading="loading" type="primary" @click="queryData(1)">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table
      v-loading="loading"
      :data="tableData"
      border
      height="500"
      :header-cell-style="{
        background: '#f2f8fe',
        color: '#333',
        fontSize: '12px',
        fontWeight: '600',
        lineHeight: '27px',
        padding: 0
      }"
      :row-style="{
        fontSize: '12px'
      }"
      :cell-style="{
        padding: '5px 0',
        textAlign: 'left'
      }"
    >
      <el-table-column
        prop="code"
        label="编码"
        width="120px"
      />
      <el-table-column
        prop="name"
        label="名称"
        width="200px"
      />
      <el-table-column
        prop="positionName"
        label="岗位"
      />
    </el-table>

    <Pagination :pagination="pagination" @pagination-change="handleTablePaginationChange" />
  </div>
</template>

<script>
import { apiSlicedQueryOrgsP } from '@/api/common'
export default {
  data() {
    return {
      conditions: {
        name: '',
        code: '',
        showAllChildrenOrg: 1,
        displayableOrgKinds: 'psm',
        showPsm: 1,
        parentId: 'orgRoot'
      },
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      tableData: []
    }
  },
  created() {},
  methods: {
    async queryData(page) {
      if (page) {
        this.pagination.page = page
      }
      this.loading = true
      const params = {
        ...this.conditions,
        ...this.pagination
      }
      const formData = new FormData()
      for (const key in params) {
        formData.append(key, params[key])
      }
      try {
        const { data: { Rows, Total }} = await apiSlicedQueryOrgsP(formData)
        this.pagination.totalCount = Total
        this.loading = false
        this.tableData = Rows
      } catch (e) {
        this.loading = false
      }
    },
    reset() {
      this.conditions.name = ''
      this.conditions.code = ''
    },
    handleTablePaginationChange(page) {
      Object.assign(this.pagination, page)
      this.queryData()
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/client-manage/components/userDialog.vue